import Helper from './Helper';

class FixedBackgroundSection {
  constructor(config = {}) {
    const {
      fixedBgSelector,
      bgWrapperClass
    } = config;

    this.fixedBgSelector = fixedBgSelector;
    this.fixedBgs = document.querySelectorAll(fixedBgSelector);
    this.fixedBgsArray = Array.prototype.slice.call(this.fixedBgs);
    this.bgWrapperClass = bgWrapperClass || 'white-bg';

    if(this.fixedBgs){
      this.addWrappers(this.fixedBgsArray);
      this.bindEvents();
    }
  }

  bindEvents() {
		window.addEventListener("scroll", e => {
			this.handleScroll(e);
		});
	}

  handleScroll(e) {
    this.fixedBgsArray.forEach((bgSection, i) => {
      if(this.isScrolledIntoView(bgSection)){
        Helper.removeClass(bgSection, 'hidden');
      } else {
        Helper.addClass(bgSection, 'hidden');
      }
    });
  }

  isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // Only completely visible elements return true:
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
  }


  addWrappers(fixedBgsArray){
    Helper.addClass(document.querySelector('body'), 'has-white-bg');
    fixedBgsArray.forEach((bgSection, i) => {
      if(i == 0){
        // console.log('get all before');
        let prevs = Helper.prevAll(bgSection).reverse();
        let wrapper = document.createElement('div');
        Helper.addClass(wrapper, this.bgWrapperClass);
        prevs.forEach(prevEl => {
          wrapper.appendChild(prevEl);
        });

        Helper.addBefore(wrapper, bgSection);
      }
      if(i == fixedBgsArray.length - 1){
        // console.log('get all to end');
        let nexts = Helper.nextAll(bgSection);
        let wrapper = document.createElement('div');
        Helper.addClass(wrapper, this.bgWrapperClass);
        nexts.forEach(nextEl => {
          wrapper.appendChild(nextEl);
        });
        Helper.addAfter(wrapper, bgSection);
      } else {
        // console.log('get all to next');
        let nexts = Helper.nextUntil(bgSection, this.fixedBgSelector);
        let wrapper = document.createElement('div');
        Helper.addClass(wrapper, this.bgWrapperClass);
        nexts.forEach(nextEl => {
          wrapper.appendChild(nextEl);
        });
        Helper.addAfter(wrapper, bgSection);
      }
    });
  }
} export default FixedBackgroundSection;

